// extracted by mini-css-extract-plugin
export var dropOver = "_nc-2";
export var dropValid = "_nc-1";
export var hidden = "_nc-3";
export var line = "_nc-0";